import { isEqual } from 'lodash';
import { useRef } from 'react';

/**
 * checks the key and value with deep equal
 * only returns the new value if it's deep unequal from the old value
 * ->  less rerenders
 *
 * @param memoFn function to be passed to useMemo
 * @param key dependencies to be passed to useMemo
 * @returns memoed result of memoFn
 */
export function useDeepMemo<TKey, TValue>(memoFn: () => TValue, key: TKey): TValue {
  const ref = useRef<{ key: TKey; value: TValue }>();

  if (!ref.current || !isEqual(key, ref.current.key)) {
    const value = memoFn();

    ref.current = {
      key,
      value: ref.current && isEqual(value, ref.current.value) ? ref.current.value : value,
    };
  }

  return ref.current.value;
}
